import axios from "axios";
import { ReservationsApiError } from "constants/customErrors";

import { CountryCode } from "custom-types/Finder";
import logError from "utils/logError";

import {
  reservationsApi,
  ReservationsApiErrors,
  ReservationsApiErrorsResponse,
} from "../services/reservations";

export type OrderRequestBody = {
  reservation: {
    cartId?: number;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    emailAddress: string;
    embedVersion?: string | null;
    dateOfBirth?: string;
    countryCode?: string;
    saveUserInfo: boolean;
    total?: number;
    subtotal?: number;
    externalOrderId?: string | null;
    tax?: number;
    menuType: string | null;
    fulfillmentMechanism: string;
    city?: string | null;
    state?: string | null;
    // TODO remove postal_code after verifying that the camel case variant works.
    postal_code?: string | null;
    postalCode?: string | null;
    address1?: string | null;
    address2?: string | null;
    paymentPreference?: string | null;
    deliveryInstructions?: string | null;
    coordinates?: {
      lat: number;
      lng: number;
    };
    addressType?: string | null;
    medicalCardState?: string;
    medicalCardNumber?: string;
    medicalCardExpiration?: string;
    scheduled?: boolean;
    startOfScheduledWindow?: string;
    endOfScheduledWindow?: string;
    totalDiscountsCents?: number;
  };
};

const createAndLogErrors = (errors: ReservationsApiErrors) =>
  errors.map((error) => {
    logError(error.detail, {
      functionName: "createOrder",
      service: "reservations",
    });
    return new ReservationsApiError(error);
  });

const createOrder = async (
  sessionId: string,
  orderBody: OrderRequestBody,
  domainCountryCode: CountryCode = "US"
) => {
  try {
    const { data } = await reservationsApi({ domainCountryCode }).post(
      "/reservations",
      orderBody,
      {
        headers: {
          "X-Leafly-Id": sessionId,
        },
      }
    );

    if (data.errors) {
      throw data.errors;
    }

    return data;
  } catch (e) {
    const errorData =
      axios.isAxiosError(e) &&
      (e.response?.data as ReservationsApiErrorsResponse)?.errors;

    if (errorData) {
      const errors = createAndLogErrors(errorData);

      throw errors;
    } else if (Array.isArray(e)) {
      const errors = createAndLogErrors(e as ReservationsApiErrors);

      throw errors;
    } else {
      logError(e.message || "reservationUnknownError", {
        functionName: "createOrder",
        service: "reservations",
        statusCode: e.code || "UNKNOWN",
      });

      throw e;
    }
  }
};

export default createOrder;
